import styled from 'styled-components';
import { Direction } from './types';

const getTrianglePosition = (direction) => {
  const positions = {
    [Direction.Left]: { top: '50%', left: '-11px', transform: 'translateY(-50%)' },
    [Direction.Right]: { top: '50%', left: '100%', transform: 'translateY(-50%) translateX(-1px)' },
    [Direction.Top]: { top: '-11px', left: '50%', transform: 'translateX(-50%)' },
    [Direction.Bottom]: { top: '100%', left: '50%', transform: 'translateX(-50%) translateY(-1px)' }
  };
  return positions[direction] || { display: 'none' };
};

const getTriangleStyles = (direction) => {
  const colors = { solid: '#000000a6', transparent: 'transparent' };
  return (
    {
      [Direction.Left]: {
        borderRight: `12px solid ${colors.solid}`,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent'
      },
      [Direction.Right]: {
        borderLeft: `12px solid ${colors.solid}`,
        borderTop: '12px solid transparent',
        borderBottom: '12px solid transparent'
      },
      [Direction.Top]: {
        borderBottom: `12px solid ${colors.solid}`,
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent'
      },
      [Direction.Bottom]: {
        borderTop: `12px solid ${colors.solid}`,
        borderLeft: '12px solid transparent',
        borderRight: '12px solid transparent'
      }
    }[direction] || {}
  );
};
export const Wrapper = styled.div<{
  width?: number;
  height?: number | string;
  visible?: boolean;
  sidebarWidth?: number;
}>`
  position: fixed;
  top: ${({ sidebarWidth }) => (sidebarWidth ? '50px' : '0')};
  left: ${({ sidebarWidth }) => (sidebarWidth ? `${sidebarWidth}px` : '0')};
  z-index: 100;
  width: ${({ width }) => `${width}px`};
  height: ${({ height }) => (typeof height === 'string' ? height : `${height}px`)};
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  background: transparent;
`;

Wrapper.defaultProps = {
  width: 380,
  height: 'auto',
  visible: true
};

export const Triangle = styled.div<{ direction?: Direction }>`
  position: absolute;
  width: 0;
  height: 0;
  ${({ direction }) => {
    const { top, left, transform } = getTrianglePosition(direction);
    return `top: ${top}; left: ${left}; transform: ${transform};`;
  }}
  ${({ direction }) => {
    const { borderLeft, borderRight, borderTop, borderBottom } = getTriangleStyles(direction);
    return `
      border-left: ${borderLeft || 'none'};
      border-right: ${borderRight || 'none'};
      border-top: ${borderTop || 'none'};
      border-bottom: ${borderBottom || 'none'};
    `;
  }}
`;

Triangle.defaultProps = {
  direction: Direction.Right
};

export const TopSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #000000cc;
  padding: 10px 10px 10px 20px;
  box-shadow: inset 0 -1px 0 0 #ffffff1f;
  backdrop-filter: blur(15px);
`;

export const Title = styled.h2`
  font-family: 'Heebo', sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  font-style: normal;
`;

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: none;
  &:hover {
    border-color: #ffffff66;
  }
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
    height: 60px;
    width: 6px;
    border-right-style: inset;
    border-right-width: calc(100vw + 100vh);
    border-color: inherit;
  }
  @media (min-width: 481px) {
    border-color: rgba(0, 0, 0, 0);
  }
  @media (max-width: 480px) {
    border-color: #ffffff66;
  }
`;

export const ContentSection = styled.div`
  background: #000000a6;
  padding: 12px 20px;

  border-bottom: 1px solid #ffffff1f;
  width: 100%;
  backdrop-filter: blur(15px);
`;

export const Description = styled.div`
  overflow: hidden;
  width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
`;

export const TooltipButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  transition-duration: 0.5s;
  &:hover {
    background: #ffffff1a;
  }
  &:focus {
    background: #ffffff33;
  }
`;
